(() => {
  const ready = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
      return;
    }
    fn();
  };

  const scheduleIdle = (fn) => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(fn, { timeout: 1200 });
      return;
    }
    window.setTimeout(fn, 180);
  };

  const normalizeExternalLinks = (root) => {
    const scope = root || document;
    const origin = window.location.origin;
    scope.querySelectorAll("a[href^='http']").forEach((link) => {
      if (!link.href || link.href.startsWith(origin)) return;
      const relParts = (link.getAttribute("rel") || "")
        .split(/\s+/)
        .map((part) => part.trim())
        .filter(Boolean);
      const relSet = new Set(relParts);
      relSet.add("nofollow");
      relSet.add("noopener");
      link.setAttribute("rel", Array.from(relSet).join(" "));
    });
  };

  const normalizeInvalidLinks = (root) => {
    const scope = root || document;
    scope
      .querySelectorAll("a:not([href]), a[href=''], a[href*='javascript:void(0)']")
      .forEach((link) => {
        link.setAttribute("href", "#");
      });
  };

  const fillMissingAlt = (root) => {
    const scope = root || document;
    const fallback = document.documentElement.getAttribute("data-shop-name") || document.title || "Image";
    scope.querySelectorAll("img:not([alt]), img[alt='']").forEach((img) => {
      img.setAttribute("alt", fallback);
    });
  };

  const patchWishlistLink = (root) => {
    const scope = root || document;
    const wishlistLink = scope.querySelector("a.header__icon--wishlist, a.h-wishlist-icon") || document.querySelector("a.header__icon--wishlist, a.h-wishlist-icon");
    if (wishlistLink) wishlistLink.setAttribute("href", "/pages/avantages");
  };

  const loadIdleScripts = () => {
    if (window.__LFDL_IDLE_SCRIPTS_LOADED__) return;
    window.__LFDL_IDLE_SCRIPTS_LOADED__ = true;

    const queue = Array.isArray(window.LFDL_IDLE_SCRIPTS)
      ? window.LFDL_IDLE_SCRIPTS.filter((src) => typeof src === "string" && src.trim() !== "")
      : [];
    if (!queue.length) return;

    const loaded = (window.__LFDL_IDLE_SCRIPTS_SET__ = window.__LFDL_IDLE_SCRIPTS_SET__ || {});
    queue.forEach((src) => {
      if (loaded[src] || document.querySelector('script[src="' + src + '"]')) return;
      loaded[src] = true;
      const script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.async = false;
      script.dataset.lfdlIdle = "1";
      document.body.appendChild(script);
    });
  };

  const run = (root) => {
    patchWishlistLink(root);
    scheduleIdle(() => {
      normalizeExternalLinks(root);
      normalizeInvalidLinks(root);
      fillMissingAlt(root);
      loadIdleScripts();
    });
  };

  ready(() => run(document));
  document.addEventListener("shopify:section:load", (event) => {
    run(event && event.target ? event.target : document);
  });
})();
